import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-save-dialog.component',
  templateUrl: './save-dialog.component.html',
  styleUrls: ['./save-dialog.component.css']
})
export class SaveChangesComponent implements OnInit {

  action: string;
  dialogData: any;
  document:any;

  constructor(public dialogRef: MatDialogRef<SaveChangesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

      this.dialogData = { ...data };
      this.action = this.dialogData.action;
     }

  ngOnInit(): void {
  }
  
  delete(){
    this.dialogRef.close({ event: this.action });
  }
  cancel() {
    this.dialogRef.close();
  }
}
